import { DASHBOARD_CARDS, DetailViewId } from './types';

export interface ApplicationModulesDashboardProps {
  onOpen: (view: DetailViewId) => void;
}

/**
 * The "Application Modules" card grid — clickable navigation cards, each
 * opening a dedicated detail view. Ported from view2.js's
 * renderDashboardGridHtml()/wireDashboardGrid().
 *
 * Every card is available for every application regardless of security
 * impact level. Modules without data (e.g. Security Summary for an app with
 * no Confluence document) show their own empty state.
 */
export function ApplicationModulesDashboard({
  onOpen,
}: ApplicationModulesDashboardProps) {
  return (
    <div className="card modules-card">
      <h4>Application Modules</h4>
      <div className="dashboard-grid" role="list">
        {DASHBOARD_CARDS.map(card => {
          const Icon = card.Icon;
          return (
            <button
              key={card.id}
              type="button"
              className="dashboard-card"
              onClick={() => onOpen(card.id)}
            >
              <span className="dashboard-card-icon" aria-hidden="true">
                <Icon />
              </span>
              <span className="dashboard-card-label">{card.label}</span>
            </button>
          );
        })}
      </div>
    </div>
  );
}
